import {
  createContext,
  useCallback,
  useRef,
  useState,
  type ReactNode,
} from 'react';
import { Modal } from '../shared/ui/Modal/Modal';
import { ConfirmModal } from './ConfirmModal';

// eslint-disable-next-line react-refresh/only-export-components
export const ConfirmContext = createContext<
  ((text: string) => Promise<boolean>) | null
>(null);

type ConfirmProviderProps = {
  children: ReactNode;
};

type ConfirmState = {
  text: string;
};

export const ConfirmProvider = ({ children }: ConfirmProviderProps) => {
  const resolverRef = useRef<((value: boolean) => void) | null>(null);
  const [state, setState] = useState<ConfirmState | null>(null);

  const confirm = useCallback((text: string) => {
    return new Promise<boolean>((resolve) => {
      resolverRef.current = resolve;
      setState({ text });
    });
  }, []);

  const handleConfirm = () => {
    resolverRef.current?.(true);
    resolverRef.current = null;
    setState(null);
  };

  const handleCancel = () => {
    resolverRef.current?.(false);
    resolverRef.current = null;
    setState(null);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}

      <Modal
        isOpen={state != null}
        onClose={handleCancel}
        size="sm"
        showCloseBtn={false}
      >
        {state && (
          <ConfirmModal
            text={state.text}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
          />
        )}
      </Modal>
    </ConfirmContext.Provider>
  );
};
